import React from "react";
import products from "../data/wholesaleProducts";
import { ProductCard } from "./product";
const money = (n) => `$${n.toFixed(2)}`;
export default function ProductDetail({
  product,
  size,
  setSize,
  add,
  shop,
  openProduct,
}) {
  const related = products
    .filter((x) => x.category === product.category && x.id !== product.id)
    .slice(0, 4);
  return (
    <main className="detail-page">
      <div className="crumb">
        <button onClick={() => shop(product.category)}>
          COLLECTION / {product.category}
        </button>
        <span>{product.sku}</span>
      </div>
      <section className="product-focus">
        <div className="gallery">
          <img src={product.images[0]} alt={product.title} />
          <span>ORIGINAL DELMORIAN PRODUCT STUDY</span>
        </div>
        <aside className="buy-box">
          <small>
            {product.category} · {product.badge || "DAILY ESSENTIAL"}
          </small>
          <h1>{product.title}</h1>
          <p className="lead">{product.summary}</p>
          <b className="detail-price">{money(product.price)}</b>
          <label>SELECT FORMAT</label>
          <div className="sizes">
            {product.sizes.map((x) => (
              <button
                className={size === x ? "active" : ""}
                onClick={() => setSize(x)}
                key={x}
              >
                {x}
              </button>
            ))}
          </div>
          <button className="add" onClick={add}>
            ADD TO BAG <b>↗</b>
          </button>
          <p className="terms">
            Ships in 1–2 business days · Flat-rate shipping $9.90
          </p>
          {product.details.map(([t, b], i) => (
            <details open={i === 0} key={t}>
              <summary>
                {t}
                <b>+</b>
              </summary>
              <p>{b}</p>
            </details>
          ))}
        </aside>
      </section>
      <section className="related">
        <small>KEEP THE RITUAL GOING</small>
        <h2>More for this chapter.</h2>
        <div className="catalog-grid">
          {related.map((x) => (
            <ProductCard key={x.id} item={x} openProduct={openProduct} />
          ))}
        </div>
      </section>
    </main>
  );
}
